import React, { useState, useEffect } from 'react';
import {
  Table,
  Button,
  Form,
  Input,
  Space,
  Switch,
  Modal,
  message,
  Card,
} from 'antd';
import { EditOutlined, PlusOutlined, ReloadOutlined } from '@ant-design/icons';
import api from '../../../api/axios';

const AddAccount = () => {
  const [form] = Form.useForm();
  const [shops, setShops] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editingShop, setEditingShop] = useState(null);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);

 
  // ====================== FETCH SHOPS ======================
  const fetchShops = async () => {
    try {
      setLoading(true);
      const res = await api.get('/api/bankaccount');
      setShops(res.data);
    } catch (err) {
      message.error('Failed to fetch shops');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchShops();
  }, []);

  // ====================== ADD SHOP ======================
  const handleAddShop = async (values) => {
    try {
      await api.post('/api/bankaccount', values);
      message.success('✅ Shop added successfully!');
      form.resetFields();
      fetchShops();
    } catch (error) {
      console.error(error);
      message.error(error.response?.data?.error || 'Failed to add shop');
    }
  };

  // ====================== EDIT SHOP ======================
  const handleEdit = (shop) => {
    setEditingShop(shop);
    setIsEditModalVisible(true);
  };

  const handleEditSubmit = async (values) => {
    try {
      await api.put(`/api/bankaccount/${editingShop.id}`, values);
      message.success('✅ Shop updated successfully!');
      setIsEditModalVisible(false);
      fetchShops();
    } catch (error) {
      console.error(error);
      message.error('Failed to update shop');
    }
  };

  // ====================== TOGGLE ACTIVE ======================
  const toggleActive = async (id) => {
    try {
      await api.patch(`/api/bankaccount/${id}/toggle`);
      message.success('Shop status updated');
      fetchShops();
    } catch (error) {
      console.error(error);
      message.error('Failed to update shop status');
    }
  };

  // ====================== TABLE COLUMNS ======================
  const columns = [
    {
      title: 'Bank Name',
      dataIndex: 'name',
      key: 'name',
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      title: 'Account No',
      dataIndex: 'accountNumber',
      key: 'accountNumber',
    },
   
    {
      title: 'Status',
      key: 'isActive',
      render: (_, record) => (
        <Switch
          checkedChildren="Active"
          unCheckedChildren="Inactive"
          checked={record.isActive}
          onChange={() => toggleActive(record.id)}
        />
      ),
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <Space>
          <Button
            icon={<EditOutlined />}
            type="link"
            onClick={() => handleEdit(record)}
          >
            Edit
          </Button>
        </Space>
      ),
    },
  ];

  // ====================== RENDER ======================
  return (
    <div>
      {/* Add New Shop */}
      <Card
        title="Add New Account"
        bordered={false}
        style={{
          marginBottom: 24,
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          borderRadius: 8,
        }}
        extra={
          <Button
            icon={<ReloadOutlined />}
            onClick={fetchShops}
            loading={loading}
          >
            Refresh
          </Button>
        }
      >
        <Form form={form} layout="inline" onFinish={handleAddShop}>
          <Form.Item
            name="name"
            rules={[{ required: true, message: 'Please enter bank name' }]}
          >
            <Input placeholder="Bank Name" />
          </Form.Item>

          <Form.Item
            name="accountNumber"
            rules={[{ required: true, message: 'Please enter account number' }]}
          >
            <Input placeholder="Account Number" />
          </Form.Item>

         

          <Form.Item>
            <Button type="primary" htmlType="submit" icon={<PlusOutlined />}>
              Add Bank Account
            </Button>
          </Form.Item>
        </Form>
      </Card>

      {/* Shop List */}
      <Card
        title="Bank Account List"
        bordered={false}
        style={{
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          borderRadius: 8,
        }}
      >
        <Table
          columns={columns}
          dataSource={shops}
          rowKey="id"
          loading={loading}
          pagination={{ pageSize: 6 }}
        />
      </Card>

      {/* Edit Modal */}
      <Modal
        title="Edit Bank Account"
        open={isEditModalVisible}
        onCancel={() => setIsEditModalVisible(false)}
        footer={null}
      >
        <Form
          layout="vertical"
          initialValues={editingShop}
          onFinish={handleEditSubmit}
        >
          <Form.Item
            name="name"
            label="Bank Name"
            rules={[{ required: true, message: 'Please enter bank name' }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            name="accountNumber"
            label="Account Number"
            rules={[{ required: true, message: 'Please enter account number' }]}
          >
            <Input />
          </Form.Item>

         

          <Form.Item>
            <Button type="primary" htmlType="submit" block>
              Update Account
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default AddAccount;
